/* flow */

var cleanStateKey = function cleanStateKey(key) {
  return key === null || typeof key === 'undefined' ? 'main' : key.toString();
};

export default cleanStateKey;


//////////////////
// WEBPACK FOOTER
// ./~/radium/es/clean-state-key.js
// module id = 173
// module chunks = 0